import { apiFetch } from '$lib/api/helpers';
import type { UnitDomainGraphResponse } from '$lib/types/domain_graph';
import type { Unit, UnitRequest } from '$lib/types/unit';

const PATH = '/units/';

export async function fetchUnits() {
	return apiFetch<Array<Unit>>(PATH);
}

export async function fetchUnit(id: number) {
	return apiFetch<Unit>(`${PATH}${id}/`);
}

export async function createUnit(unit: UnitRequest) {
	return apiFetch<Unit>(PATH, {
		method: 'POST',
		body: JSON.stringify(unit)
	});
}

export async function updateUnit(id: number, unit: Partial<UnitRequest>) {
	return apiFetch<Unit>(`${PATH}${id}/`, {
		method: 'PATCH',
		body: JSON.stringify(unit)
	});
}

export const patchUnit = updateUnit;

export async function deleteUnit(unitId: number) {
	return apiFetch<void>(`${PATH}${unitId}/`, { method: 'DELETE' });
}

export async function cloneUnit(unitId: number, name?: string) {
	return apiFetch<Unit>(`${PATH}${unitId}/clone/`, {
		method: 'POST',
		body: JSON.stringify({ name: name ?? '' })
	});
}

export async function fetchUnitDomainGraph(unitId: number) {
	return apiFetch<UnitDomainGraphResponse>(`${PATH}${unitId}/domain_graph/`);
}

export async function fetchUnitElectricalSummary(unitId: number) {
	return apiFetch<unknown>(`${PATH}${unitId}/electrical_summary/`);
}

export async function fetchUnitValidation(unitId: number) {
	return apiFetch<unknown>(`${PATH}${unitId}/validation/`);
}

export async function fetchUnitCAT6Wiring(unitId: number) {
	return apiFetch<unknown>(`${PATH}${unitId}/cat6_wiring/`);
}

export async function fetchUnitLedLogicPreview(unitId: number) {
	return apiFetch<unknown>(`${PATH}${unitId}/led_logic_preview/`);
}

export async function syncUnitLedLogic(unitId: number) {
	return apiFetch<unknown>(`${PATH}${unitId}/sync_led_logic/`, { method: 'POST' });
}

export async function cloneRoom(roomId: number) {
	return apiFetch<unknown>(`/rooms/${roomId}/clone/`, { method: 'POST' });
}
